// Import the singleton instance from the main app instead of creating a new one
import { supabase as mainSupabaseClient } from '../../../lib/supabaseClient';

// SECURITY (NFR-10): this module previously created a `supabaseAdmin` client from a
// VITE_-prefixed service-role env var, which shipped an RLS-bypass credential in the
// browser bundle. Never recreate it (CI has a grep gate against it). All site-survey
// reads/writes go through the authenticated singleton and are governed by RLS.
export const supabase = mainSupabaseClient;

/**
 * Helper function to handle Supabase errors
 * @param error Supabase error object
 * @param defaultMessage Default error message
 * @returns Formatted error message
 */
export const handleSupabaseError = (error: any, defaultMessage = 'An unexpected error occurred'): string => {
  if (!error) return defaultMessage;

  // Handle specific error codes
  if (error.code === 'PGRST116') {
    return 'Resource not found';
  }

  // Return the error message or the default message
  return error.message || error.error_description || defaultMessage;
};
